import Carousel from 'react-bootstrap/Carousel';
import Container from 'react-bootstrap/esm/Container';
import Card from 'react-bootstrap/Card';
function TestiMonies() {
    return (
        <Container className='mt-5 testimonies-section' id="testimonies">
            <h2 className='text-white'>Testimonies</h2>
            <Carousel controls={false} indicators={false} className="p-5 m-2">
                <Carousel.Item interval={2000}>
                    <Card className='shadow' bg={"dark"} text='white'>
                        <Card.Body>
                            <blockquote className="blockquote mb-0">
                                <p>
                                    {' '}
                                    Leon was amazing to work with. Not only is he highly skilled in his area of expertise, he also brought with him a genuine passion for the work that Climable does. I highly recommend working with Leon!{' '}
                                </p>
                                <a href="https://www.catchafire.org/impact/match/2446901/climable--flexible-web-development-support/">
                                    <footer className="blockquote-footer">
                                        <cite title="Source Title">  Sophie K. Researcher at  Climable</cite>
                                    </footer>
                                </a>
                            </blockquote>
                        </Card.Body>
                    </Card>
                </Carousel.Item>
                <Carousel.Item interval={2000}>
                    <Card className='shadow' bg={"dark"} text='white'>

                        <Card.Body>
                            <blockquote className="blockquote mb-0">
                                <p>
                                    {' '}
                                    Leon was great. His turnaround was super fast.{' '}
                                </p>
                                <a href="https://www.catchafire.org/impact/match/2523300/appropriate-technology-collaborative--website-technical-updates/">
                                    <footer className="blockquote-footer">
                                        Theresa S.
                                        <cite title="Source Title">Operations Director at  Appropriate Technology Collaborative</cite>
                                    </footer>
                                </a>
                            </blockquote>
                        </Card.Body>
                    </Card>
                </Carousel.Item>
            </Carousel>
        </Container>

    );
}

export default TestiMonies;